/**
 * 泰國原 rhinoshield.co.th 已收攤,改由 ASIA 主站 rhinoshield.co 的 /th 多語系子路徑服務。
 * 傳入 rhinoshield 公開網域,TH 的 .co.th 改成 .co/th,其餘 region 原樣回傳(不含 protocol)。
 */
export function toLiveRhinoshieldBase(host: string): string {
  return host.endsWith('.co.th') ? `${host.replace(/\.co\.th$/, '.co')}/th` : host
}
